import React, { useEffect, useRef } from 'react';
import Icon from '../../../components/AppIcon';

const AudioLevelMeter = ({ 
  level = 0, 
  peakLevel = 0, 
  isActive = false,
  label = "Входной уровень"
}) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef?.current;
    if (!canvas) return;

    const ctx = canvas?.getContext('2d');
    const width = canvas?.width;
    const height = canvas?.height;

    ctx?.clearRect(0, 0, width, height);

    const levelWidth = (level / 100) * width;
    const peakPosition = (peakLevel / 100) * width;

    const gradient = ctx?.createLinearGradient(0, 0, width, 0);
    gradient?.addColorStop(0, '#7A9B76');
    gradient?.addColorStop(0.7, '#C4956C');
    gradient?.addColorStop(1, '#B85C5C');

    ctx.fillStyle = gradient;
    ctx?.fillRect(0, 0, levelWidth, height);

    if (peakLevel > 0) {
      ctx.fillStyle = '#B85C5C';
      ctx?.fillRect(peakPosition - 2, 0, 4, height);
    }

    ctx.strokeStyle = 'var(--color-border)';
    ctx.lineWidth = 1;
    ctx?.strokeRect(0, 0, width, height);

  }, [level, peakLevel]);

  const getLevelColor = () => {
    if (level < 50) return 'text-success';
    if (level < 80) return 'text-warning';
    return 'text-error';
  };

  return (
    <div className="audio-level-meter bg-card rounded-lg border border-border p-4 shadow-soft">
      <div className="meter-header flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Icon 
            name={isActive ? "Mic" : "MicOff"} 
            size={18} 
            color={isActive ? "var(--color-success)" : "var(--color-muted-foreground)"} 
          />
          <span className="text-sm font-heading font-medium text-foreground">
            {label}
          </span>
        </div>
        
        <span className={`text-sm font-mono font-semibold ${getLevelColor()}`}>
          {level?.toFixed(0)} dB
        </span>
      </div>
      <div className="meter-canvas-container mb-2">
        <canvas 
          ref={canvasRef} 
          width={400} 
          height={24}
          className="w-full h-6 rounded"
        />
      </div>
      <div className="meter-scale flex justify-between text-xs font-mono text-muted-foreground">
        <span>-60</span>
        <span>-40</span>
        <span>-20</span>
        <span>0</span>
      </div>
    </div>
  );
};

export default AudioLevelMeter;